import { SystemGroup, SystemPlan } from "@ews/react-data";
import Icon from "@ews/react-icons";
import { useL10n } from "@ews/react-localization-context";
import { formatLogicalAddress, NoDeviceNumber, NumberGroup } from "@ews/zlt-events";
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonInput, IonItem, IonList, IonListHeader, IonText } from "@ionic/react";
import React, { useRef, useState } from "react";
import { SystemElement } from "../../../ReactData/system";
import { deviceList } from "../../deviceList";
// import { fileIconSize } from "../../Plan";
import { getDeviceIconsFilePath } from "../Element/Element";
import style from "./ElementList.module.scss";
import { Props } from "./types";


export const fileIconSize = "";



const ElementList: React.FC<Props> = ({
    iconData,
    onGroup,
    onElement,
    onChange,
    onFloor,
    groups,
    currentElement,
    currentPlan,
    isMainPlan,
    plans = [],
    showFloors = true
}) =>
{

    const { translate: t } = useL10n();

    const [searchElementValue, setSearchElementValue] = useState("");
    const [searchIconValue, setSearchIconValue] = useState("");
    const searchElementRef = useRef<HTMLIonInputElement>(null);
    const searchIconRef = useRef<HTMLIonInputElement>(null);
    const numberGroupHeader: Record<string, boolean> = {};
    const numberGroups: SystemGroup[][] = [];

    if (!isMainPlan) {
        groups.forEach((group) =>
        {
            numberGroups[group.numberGroup!] = numberGroups[group.numberGroup!] || [];
            numberGroups[group.numberGroup!].push(group);
        });
    }

    function isHighlighted(groupId: number, id: number, numberGroup: number)
    {
        if (!currentElement) return false;

        return groupId === currentElement.groupId! &&
            id === currentElement.id! &&
            numberGroup === currentElement.numberGroup;
    }
    function isSelectedFloor(floor: SystemPlan, current?: SystemPlan)
    {
        if (!current) return false;
        return floor.id === current.id;
    }

    return <IonCard className={`${style.container} ${showFloors ? "" : style.fullSize}`}>
        <IonCardHeader color={"primary"}>
            {isMainPlan ?
                currentPlan ?
                    <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <IonText>{currentPlan.label}</IonText>
                    </div>
                    :
                    null
                :
                <div className={style.header}>

                    <div className={style.headItem}>
                        <div>
                            <IonText>
                                {
                                    currentElement ?
                                        `${formatLogicalAddress(currentElement?.groupId!, currentElement.id || NoDeviceNumber, currentElement.numberGroup || NumberGroup.Zone)} ${currentElement.text}`
                                        :
                                        ""
                                }
                            </IonText>
                        </div>
                    </div>

                    <div className={`${style.headItem}`}>
                        <div className={style.currentDevice}>
                            {iconData ? <img
                                className={style.img}
                                src={getDeviceIconsFilePath(`${fileIconSize}${iconData.img}_0`)}
                                alt=""
                                loading="lazy"
                                onError={(e) =>
                                {
                                    const target = e.target as HTMLImageElement;
                                    target.src = getDeviceIconsFilePath("question");
                                }}
                            /> : null}
                            <IonText>{iconData ? iconData.name.trim() : ""}</IonText>
                        </div>
                    </div>
                </div>
            }
        </IonCardHeader>
        <IonCardContent className={` ${!showFloors ? style.fullContentHeight : ""}`}>
            {isMainPlan ? <IonList className={style.mainPlanList}>
                {plans.filter(plan => !plan.labelPositionX || !plan.labelPositionY).map((plan) =>
                {
                    if (!("isMain" in plan)) return null;
                    if (plan.isMain) return null;

                    return <IonItem
                        key={plan.label}
                        className={style.btn}
                    >
                        <IonButton
                            color={isSelectedFloor(plan, currentPlan) ? "primary" : "secondary"}
                            style={{ width: "100%", display: "flex", justifyContent: "center", }}
                            onClick={() =>
                            {
                                onFloor && onFloor(currentPlan ? undefined : plan);
                            }}
                        >
                            <div
                                style={{ padding: "15px 0" }}>
                                {plan.label}
                            </div>
                        </IonButton>
                    </IonItem>;
                })}

            </IonList> :
                <div className={style.contentContainer}>

                    {onGroup ? <div className={style.content}>
                        <IonItem
                            lines="full"
                        >
                            <div className={style.searchHeader}>
                                <IonText>{t("TD_ELEM2")}</IonText>
                                {/*     <div
                                    className={style.search}
                                > */}
                                <IonInput
                                    label=""
                                    type="search"
                                    ref={searchElementRef}
                                    onIonInput={({ detail }) => setSearchElementValue(detail.value || "")} />
                                <IonButton expand="full" color={"success"}>
                                    <Icon icon={"search"} onClick={() => { searchElementRef.current?.click(); }} />
                                </IonButton>
                                {/*  </div> */}
                            </div>
                        </IonItem>
                        {
                            <IonList>
                                {numberGroups.map((groups, index) =>
                                {
                                    return <React.Fragment key={index}>
                                        <IonListHeader
                                            color={'warning'}
                                        >{t(`[REACT_GROUP_RANGE_PICKER_${index}]`)}
                                        </IonListHeader>
                                        {groups.map((group, gIndex) =>
                                        {

                                            const elements = group.elements?.filter((element: SystemElement) =>
                                            {
                                                if (searchElementValue === "") return true;

                                                const hasLetters = /^[A-Za-z\s]*$/.test(searchElementValue);

                                                if (hasLetters) {
                                                    return element.text?.toLocaleLowerCase().includes(searchElementValue.toLocaleLowerCase());
                                                }
                                                else if (searchElementValue.includes("/") && element.id && element.groupId) {
                                                    const [groupId, id] = searchElementValue.split("/").map(item => Number(item.trim()));
                                                    return element.id === id && groupId === element.groupId;
                                                }
                                                else {
                                                    const value = Number(searchElementValue);
                                                    return value === element.id || value === element.groupId;
                                                }

                                            }
                                            );


                                            return elements?.length ?
                                                <React.Fragment key={`group-${gIndex}`} >
                                                    <IonListHeader
                                                        key={group.id}
                                                        color={"primary"}
                                                    >{`${group.id} ${group.text}`}
                                                    </IonListHeader>
                                                    {onElement ? elements?.map((element: SystemElement, eIndex: number) =>
                                                    {
                                                        return <IonItem
                                                            lines="full"
                                                            color={
                                                                isHighlighted(element.groupId!, element.id!, element.numberGroup!)
                                                                    ? "success" : undefined}
                                                            key={eIndex}>
                                                            <IonButton
                                                                color={"secondary"}
                                                                onClick={() =>
                                                                {
                                                                    if (onGroup) onGroup(group);
                                                                    if (onElement) onElement(element);
                                                                }}
                                                            >
                                                                {`${formatLogicalAddress(group.id!, element.id || NoDeviceNumber, group.numberGroup || NumberGroup.Zone)} ${element.text}`}
                                                            </IonButton>
                                                        </IonItem>;
                                                    }) : null}
                                                </React.Fragment>
                                                :
                                                <React.Fragment key={`$group-${gIndex}`} />;
                                        })}
                                    </React.Fragment>;
                                })}

                            </IonList>
                        }</div> : null}
                    <div className={style.content}>
                        <IonItem
                            lines="full"
                        >
                            <div className={style.searchHeader}>
                                <IonText>{t("COM_LOCALISE_HEADING_TRANSLATIONS_LEGEND_ICON")}</IonText>
                                {/*  <div
                                    className={style.search}
                                > */}
                                <IonInput
                                    label=""
                                    type="search"
                                    ref={searchIconRef}
                                    onIonInput={({ detail }) => setSearchIconValue(detail.value || "")} />
                                <IonButton expand="full" color={"success"}>
                                    <Icon icon={"search"} onClick={() => { searchIconRef.current?.click(); }} />
                                </IonButton>
                                {/*  </div> */}
                            </div>

                        </IonItem>
                        <IonList>
                            {Object.keys(deviceList)
                                .sort((a, b) => a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase()))
                                .filter((key) =>
                                    key.toLocaleLowerCase().includes(searchIconValue.toLocaleLowerCase()))
                                .map((key) =>
                                {
                                    const { name } = deviceList[key as keyof typeof deviceList];

                                    return <IonItem
                                        lines="full"
                                        key={key}
                                        className={style.device}
                                        color={iconData && iconData.img === key ? "success" : undefined}
                                        onClick={() => { if (onChange) onChange({ img: key, name }); }}>
                                        <img
                                            slot="start"
                                            className={style.img}
                                            width={25}
                                            height={25}
                                            src={getDeviceIconsFilePath(`${fileIconSize}${key}_0`)}
                                            loading="lazy"
                                            alt=""
                                            onError={(e) =>
                                            {
                                                const target = e.target as HTMLImageElement;
                                                target.src = getDeviceIconsFilePath("question");
                                            }}
                                        />
                                        <p
                                            slot="end"
                                            className={style.text}
                                        >
                                            {name}
                                        </p>
                                    </IonItem>;
                                })}
                        </IonList>
                    </div>
                </div>
            }
        </IonCardContent>
    </IonCard>;
};

export default ElementList;
